import type { TravelAddOns } from '@/types/api'

/**
 * A booking's add-ons as a short sentence for exports and plain-text cells:
 * "Return leg · +6 h", or an empty string when nothing was added.
 *
 * The server words it (`summary`); the fallback only exists for a response
 * that somehow carries the flags without the label.
 */
export function describeAddOns(addOns: TravelAddOns | null | undefined): string {
  if (!addOns || !addOns.any) return ''
  return (
    addOns.summary ??
    [addOns.returnLeg ? 'Return leg' : null, addOns.extraHours > 0 ? `+${addOns.extraHours} h` : null]
      .filter(Boolean)
      .join(' · ')
  )
}
